<template>
    <div id="full-screen-modal">
        <div class="edit-header">
            <slot name="toolbar"></slot>
        </div>
        <div class="edit-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FullScreenModal',
}
</script>

<style lang="scss" scoped>
#full-screen-modal {
    z-index: 1002;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100%;
    background-color: var(--primary);
    .edit-header {
        padding: 10px 20px;
        background-color: var(--primary);
        border-bottom: 2px solid var(--secondary);
        height: 80px;

        button,
        a {
            cursor: pointer;
        }
    }
    .edit-body {
        height: calc(100vh - 80px);
    }
}
</style>
